/* This file handles getting utm parameters from the URL and setting them as cookies
* and then watching for a hubspot form to load and setting the utm parameters as hidden fields
* in the form.
*/

/** Get the value of a URL parameter by name
 * @param {string} name - The name of the URL parameter to retrieve
 * @return {string|null} - The value of the URL parameter or null if not found
*/
function getURLParameter(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
}

/**
 * Retrieve a cookie by name
 * @param {string} name - The name of the cookie to retrieve
 * @returns {string[]|null} cookie - The cookie value or null if not found
 */
function getCookie(name) {
    const cArr = document.cookie.split(';')
    for (let i = 0; i < cArr.length; i++) {
        const cookie = cArr[i].split('=', 2)
        cookie[0] = cookie[0].replace(/^\s+/, '')
        if (cookie[0] == name) {
            return cookie
        }
    }
    return null;
}

/**
 * Set cookie with the given name, value, and expiration days
 * @param {string} name - The name of the cookie to set
 * @param {string} value - The value of the cookie to set
 * @param {Number} days - The number of days until the cookie expires
 */
function setCookie(name, value, days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    const expires = '; expires=' + date.toGMTString()
    document.cookie = name + '=' + value + expires + '; path=/'
}

window.addEventListener("load", () => {
    // Retrieve URL parameters
    let utm_source = getURLParameter("utm_source");
    let utm_medium = getURLParameter("utm_medium");
    let utm_campaign = getURLParameter("utm_campaign");
    let utm_term = getURLParameter("utm_term");
    let utm_content = getURLParameter("utm_content");

    // Set cookie values
    if (utm_source || utm_medium || utm_campaign || utm_term || utm_content) {
        let dict = {};
        dict.utm_source = utm_source;
        dict.utm_medium = utm_medium;
        dict.utm_campaign = utm_campaign;
        dict.utm_term = utm_term;
        dict.utm_content = utm_content;
        setCookie("utm_params", JSON.stringify(dict), 365);
    }
});

// Export for HS form module
export { getCookie };
